import { useState } from 'react';
import BasicMenu from './BasicMenu';
import { isValidDate } from '../../../utils/functions';

const Announcement = ({
  title,
  details,
  deleteHandler,
  editHandler,
  assignedBy,
  createdAt,
  canEdit = false,
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div
      className="task-item"
      style={{ cursor: canEdit ? 'pointer' : 'default' }}
      onClick={(e) => {
        e.stopPropagation();
        if (canEdit) editHandler();
      }}
    >
      <div className="task-header" style={{ margin: 0, padding: 0 }}>
        <p
          style={{
            margin: 0,
            padding: 0,
            fontSize: '16px',
            fontWeight: 700,
            color: 'black',
          }}
        >
          {title}
        </p>

        {canEdit && (
          <div onClick={(e) => e.stopPropagation()}>
            <BasicMenu deleteHandler={deleteHandler} editHandler={editHandler} />
          </div>
        )}
      </div>
      <div className="task-footer">
        {assignedBy && (
          <p style={{ margin: 0, padding: 0, lineHeight: 1.1, fontSize: '14px' }}>
            Written By:&nbsp;{assignedBy}
          </p>
        )}
        {createdAt && isValidDate(new Date(createdAt)) && (
          <p style={{ margin: 0, padding: 0, lineHeight: 1.1, fontSize: '14px' }}>
            Announcement Added:&nbsp;
            {new Date(createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </p>
        )}

        {details && (
          <p
            style={{
              marginTop: 20,
              marginBottom: 0,
              color: 'black',
              fontSize: '14px',
              lineHeight: 1.2,
              whiteSpace: 'pre-wrap',
            }}
          >
            {expanded ? details : details.length > 280 ? `${details.slice(0, 280)}...` : details}

            {details.length > 280 && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded(!expanded);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'blue',
                  cursor: 'pointer',
                  padding: '5px 0',
                  marginLeft: '5px',
                  display: 'inline',
                  fontSize: '14px',
                }}
                onMouseEnter={(e) => (e.target.style.color = 'darkblue')}
                onMouseLeave={(e) => (e.target.style.color = 'blue')}
              >
                {expanded ? 'Collapse' : 'Expand'}
              </span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};
export default Announcement;
